<template>
  <div class="pg-date-picker-range">
    <DatePicker
      class="pg-date-picker-range__date pg-date-picker-range__date-one"
      :class="{ 'pg-date-picker-range__datetime': type === 'datetime' }"
      size="small"
      :format="showFormatCom"
      :value-format="formatCom"
      v-bind="$attrs"
      :placeholder="placeholder1"
      :type="type"
      :pickerOptions="pickerOptions1"
      :clearable="false"
      :value="value1"
      @input="onInput1"
      @change="onChange1"
      @focus="onFocus"
      @blur="onBlur"
    />
    <span class="pg-date-picker-range__span">至</span>
    <DatePicker
      class="pg-date-picker-range__date pg-date-picker-range__date-two"
      :class="{ 'pg-date-picker-range__datetime': type === 'datetime' }"
      size="small"
      ref="twoRef"
      :format="showFormatCom"
      :value-format="formatCom"
      v-bind="$attrs"
      :placeholder="placeholder2"
      default-time="23:59:59"
      :type="type"
      :pickerOptions="pickerOptions2"
      :clearable="false"
      :value="value2"
      @input="onInput2"
      @change="onChange"
    />
    <i
      class="pg-date-picker-range__date-close-icon el-icon-circle-close"
      v-if="clearable && (!!value1 || !!value2)"
      @click="onClear"
    ></i>
  </div>
</template>
<script setup>
import { DatePicker } from 'element-ui'
import { computed, ref } from 'vue'
import { filters } from '../../../utils/index'

const props = defineProps({
  value: Array,
  type: {
    type: String,
    default: 'date',
  },
  format: String,
  showFormat: String,
  placeholder1: {
    type: String,
    default: '开始日期',
  },
  placeholder2: {
    type: String,
    default: '结束日期',
  },
  clearable: {
    type: Boolean,
    default: true,
  },
  // 日期范围天数
  dateRange: {
    type: Number,
  },
})

const emit = defineEmits(['input', 'change', 'on-change'])

const showFormatCom = computed(() => {
  if (props.showFormat) {
    return props.showFormat
  } else if (props.type === 'datetime') {
    return 'yyyy/MM/dd HH:mm:ss'
  } else {
    return 'yyyy/MM/dd'
  }
})
const formatCom = computed(() => {
  if (props.format) {
    return props.format
  } else if (props.type === 'datetime') {
    return 'yyyy-MM-dd HH:mm:ss'
  } else {
    return 'yyyy-MM-dd'
  }
})

const isFocus = ref(false)
const onFocus = () => {
  isFocus.value = true
}
const onBlur = () => {
  isFocus.value = false
}

const value1 = computed(() => (!!props.value && props.value.length === 2 ? props.value[0] : null))
const value2 = computed(() => (!!props.value && props.value.length === 2 ? props.value[1] : null))
const twoRef = ref(null)
const onInput1 = (val) => {
  if (!val && !value2.value) {
    emit('input', null)
  } else {
    emit('input', [val, value2.value])
  }
  setTimeout(() => {
    if (!isFocus.value) {
      twoRef.value?.focus()
    }
  })
}
const onInput2 = (val) => {
  if (!val && !value1.value) {
    emit('input', null)
  } else {
    emit('input', [value1.value, val])
  }
}

const onChange = () => {
  emit('change', props.value)
  if (value1.value && value2.value) {
    emit('on-change', props.value)
  }
}
const onChange1 = () => {
  onChange()
  if (props.type === 'datetime') {
    setTimeout(() => {
      if (!isFocus.value) {
        twoRef.value?.focus()
      }
    })
  }
}
const onClear = () => {
  emit('input', null)
  emit('change', null)
  emit('on-change', null)
}

const pickerOptions1 = computed(() => {
  return {
    disabledDate: (time) => {
      if (props.dateRange && value2.value) {
        return (
          new Date(`${filters(value2.value, 'date', 'YYYY-MM-DD')} 00:00:00`).getTime() -
            props.dateRange * 24 * 60 * 60 * 1000 >
            time.getTime() ||
          time.getTime() >
            new Date(`${filters(value2.value, 'date', 'YYYY-MM-DD')} 00:00:00`).getTime()
        )
      } else if (value2.value) {
        return (
          time.getTime() >
          new Date(`${filters(value2.value, 'date', 'YYYY-MM-DD')} 00:00:00`).getTime()
        )
      }
      return false
    },
  }
})
const pickerOptions2 = computed(() => {
  return {
    disabledDate: (time) => {
      if (props.dateRange && value1.value) {
        return (
          time.getTime() - props.dateRange * 24 * 60 * 60 * 1000 >
            new Date(`${filters(value1.value, 'date', 'YYYY-MM-DD')} 00:00:00`).getTime() ||
          time.getTime() <
            new Date(`${filters(value1.value, 'date', 'YYYY-MM-DD')} 00:00:00`).getTime()
        )
      } else if (value1.value) {
        return (
          time.getTime() <
          new Date(`${filters(value1.value, 'date', 'YYYY-MM-DD')} 00:00:00`).getTime()
        )
      }
      return false
    },
  }
})
</script>
<style lang="scss">
@import '../style/date-picker-range.scss';
</style>
